module.exports = __webpack_public_path__ + "media/images/countrysquared/vn-eb91574a207c444813c4c2cdd04f74eb.svg";